import { Icon, Select, SelectContent, SelectTrigger, SelectItem, SelectValue } from '@shopflo/ui'
import { Percent, CurrencyInr } from '@phosphor-icons/react'
import { AmountType, CouponType, DiscountFieldPaths, UiConfigDiscountType } from 'src/lib/types/discountsV2'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import PurchaseConditions from '../AmountOff/PurchaseConditions'
import DiscountPricingInput from '../../../common/DiscountPricingInput'

import FormErrorText from 'src/components/common/FormErrorText'
import { useLocale } from 'src/lib/hooks/useLocal'

const DiscountApplicationRulesShipping = () => {
  const {
    state: { entitlement, errors, uiConfig }
  } = useDiscountForm()
  const { t } = useLocale()

  if (uiConfig.type !== UiConfigDiscountType.SHIPPING || entitlement.type !== CouponType.SHIPPING) {
    return null
  }

  return (
    <div className='flex flex-col gap-3 w-full'>
      <h3 className='text-text-sm-semibold text-zinc-800'>{t('discounts_v2.set_discount')}</h3>

      <div className='grid grid-cols-2 gap-3 w-full pb-6'>
        <div>
          <DiscountPricingInput error={errors[DiscountFieldPaths.CONCESSION_AMOUNT]} />
        </div>

        <div>
          <Select value='on_shipping' disabled>
            <SelectTrigger
              className='w-full h-9 bg-zinc-50 rounded-lg opacity-100 cursor-default text-zinc-800'
              showCaret={false}
            >
              <span className='p-1'>{t('discounts_v2.on_all_shipping_rates')}</span>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value='on_shipping'>{t('discounts_v2.on_all_shipping_rates')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <PurchaseConditions />
    </div>
  )
}

export default DiscountApplicationRulesShipping
